<template>
  <div id="app" :class="['app', {'is-ie': isIE}, {'is-result': isVisible.SortResult}]">
    <div class="app-wrap">
      <!-- <transition name="fade">
        <page-main-visual v-show="isVisible.MainVisual" ref="opening" :isSP="isSP" />
      </transition> -->
      <transition name="fade">
        <page-sort-start v-show="isVisible.SortStart" ref="start" @clickedButton="sortStart" />
      </transition>
      <transition name="fade">
        <page-sort-select v-show="isVisible.SortSelect" ref="select" @clickedBack="sortReset" @selectedChoices="sortChoices" />
      </transition>
      <transition name="fade">
        <screen-wait v-show="isVisible.ScreenWait" />
      </transition>
      <page-sort-result v-show="isVisible.SortResult" ref="result" :is-footer-show="isFooterShow" :selectedStatus="status" :isSP="isSP" @clickedRetry="sortRetry" @sortChoices="sortChoices" />
      <transition name="fade">
        <part-logo v-show="isVisible.PartLogo" @clikedLogo="toStart" />
      </transition>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'

// import PageMainVisual from './components/PageMainVisual.vue'
import PartLogo from './components/PartLogo.vue'
import ScreenWait from './components/ScreenWait.vue'
import PageSortResult from './components/PageSortResult.vue'
import PageSortSelect from './components/PageSortSelect.vue'
import PageSortStart from './components/PageSortStart.vue'

export default {
  name: 'App',
  components: {
    // PageMainVisual,
    PageSortStart,
    PageSortSelect,
    ScreenWait,
    PageSortResult,
    PartLogo
  },
  data: () => {
    return {

      isVisible: {
        MainVisual: false,
        ScreenWait: false,
        SortResult: false,
        SortSelect: false,
        SortStart: false,
        PartLogo: false,
        ScreenError: false
      },
      status: {
        1: null,
        2: null,
        3: null,
        4: null
      },

      isFooterShow: false,
    };
  },
  computed: {
    isIE() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1;
    },
    isSP() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return userAgent.indexOf('iphone') > 0 || userAgent.indexOf('android') > 0 && userAgent.indexOf('mobile') > 0;
    },
    headerHeight() {
      return this.isSP ? 61 : 124;
    }
  },
  created() {

  },
  mounted() {
    this.start();
    if (this.isSP) this.startSP();
    this.observeFooter();
  },
  methods: {
    /**
     * スタートアニメーション
     */
    start() {
      // const _animeTime = this.isSP ? 5800 : 6600;
      // const _animeTime = 2600;
      // setTimeout(() => {
      //   this.isVisible.MainVisual = true;
      //   this.$refs.opening.show();
      // }, 100);
      // setTimeout(() => {
        // this.isVisible.MainVisual = false;
        this.isVisible.SortStart = true;
        this.isVisible.PartLogo = true;
        this.$refs.start.show();
      // }, _animeTime);
    },


    observeFooter(){
      const footerElm = document.querySelector('#footer');
      const topicUnitElm = document.querySelector('#topicUnit');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const target = entry.target;
          if(entry.isIntersecting){
            // console.log("show footer in viewport");
            this.isFooterShow = true;
          }else{
            if(target.id === "topicUnit"){
              // console.log("hide footer");
              this.isFooterShow = false;
            }
          }
        });
      });
      observer.observe(footerElm);
      observer.observe(topicUnitElm);
    },



    /**
     * 診断を始める
     */
    sortStart() {
      this.isVisible.SortStart = false;
      setTimeout(() => {
        this.isVisible.SortSelect = true;
        this.$refs.select.stepShow(0);
      }, 1000);
    },
    /**
     * 初期画面に戻る
     */
    sortReset() {
      this.isVisible.SortSelect = false;
      this.isVisible.SortStart = true;
    },
    /**
     * 選択肢を元に絞り込みを始める
     * @param data {Object} 選択した選択肢
     */
    sortChoices(data) {
      this.isVisible.SortSelect = false;
      this.isVisible.ScreenWait = true;
      this.status = data;
      setTimeout(() => this.showResult(), 100);
    },
    /**
     * 結果画面を表示する
     */
    showResult() {
      // データをAPIでコールする
      this.$refs.result.searchReview();
      setTimeout(() => {
        this.isVisible.ScreenWait = false;
        this.isVisible.SortResult = true;
      }, 2000);


    },
    /**
     * 絞り込みをやり直す
     */
    sortRetry() {
      this.isVisible.SortResult = false;
      this.isVisible.ScreenWait = true;
      this.$refs.select.sortFirst();
      setTimeout(() => {
        this.isVisible.SortSelect = true;
        this.$refs.select.stepShow(0);
        this.isVisible.ScreenWait = false;
      }, 1000);
    },

    /**
     * エラー画面を出す
     */
    showError() {
      // this.isVisible.MainVisual = false;
      this.isVisible.ScreenWait = true;
      this.isVisible.SortResult = false;
      this.isVisible.SortSelect = false;
      this.isVisible.SortStart = false;
      this.isVisible.PartLogo = true;
    },
    /**
     * 最初の画面に戻る
     */
    toStart() {
      // this.isVisible.MainVisual = false;
      this.isVisible.ScreenWait = false;
      this.isVisible.SortResult = false;
      this.isVisible.SortSelect = false;
      this.isVisible.SortStart = false;
      this.isVisible.PartLogo = false;
      // this.$refs.opening.hide();
      this.$refs.start.hide();
      this.$refs.select.sortFirst();
      this.$refs.result.initialize();
      this.$refs.result.clearCheckBox();
      window.scrollTo(0, 0);
      setTimeout(() => this.start(), 10);
    },
    /**
     * SPの時高さを調整する
     */
    setFillHeight() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    /**
     * 高さ調整を始める
     */
    startSP() {
      this.setFillHeight();
      window.addEventListener('resize', this.setFillHeight);
    }
  }
}
</script>

<style lang="scss">
@import '~@/assets/scss/transition.scss';

#app {
  position: relative;
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 400;
  color: #333;
}

.app {
  box-sizing: border-box;
  overflow: hidden;
  @include media() {
    background: url(~@/assets/images/rower_bg_pc.jpg) center/cover no-repeat fixed;
  }
  &::before{
    content: '';
    display: flex;
    width: 100%;
    height: 100vh;
    background: url(~@/assets/images/rower_bg_sp.jpg) top no-repeat;
    background-size: cover;
    background-attachment: scroll;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 0;
    overflow: auto;
    @include media() {
      display: none;
    }
  }
  &-wrap {
    box-sizing: border-box;
    height: calc(100vh - 61px);
    height: calc(var(--vh, 1vh) * 100 - 61px);
    min-height: 580/375 * 100vw;
    position: relative;
    z-index: 1;
    @include media() {
      height: calc(100vh - 124px);
      min-height: 480px;
    }
    .is-result & {
      padding: 80/375 * 100% 0 20/375 * 100%;
      height: auto;
      @include media() {
        padding: 120px 0 30px;
      }
    }
  }
  img {
    display: block;
    width: 100%;
  }
}
.no-visible {
  display: none;
}
</style>
